import {Team, User} from "@irati/types"
import domain from "@irati/utils/env/domain"
import authentication from "@irati/auth"
import {isGlobalAdmin, isManagerOfTeam, isLeaderOfTeam} from "../../helpers/user/role"

export function canModifyUserMembership(team: Team, user: User, target: User): boolean {
  if (domain.isInternal() || authentication.isUserGhost()) {
    return true
  }

  if (isLeaderOfTeam(team, user) || isGlobalAdmin(authentication.business(), user)) {
    return true
  }

  if (isManagerOfTeam(team, user)) {
    if (isLeaderOfTeam(team, target)) {
      return false
    }

    return true
  }

  return false
}
